import { getIntrinsicElementProps, slot } from "@fluentui/react-components";
import type {
  AppPreviewGalleryButtonDisplayProps,
  AppPreviewGalleryButtonDisplayState,
} from "./AppPreviewGalleryButtonDisplay.types";

export const useAppPreviewGalleryButtonDisplay = (
  props: AppPreviewGalleryButtonDisplayProps,
  ref: React.Ref<HTMLDivElement>
): AppPreviewGalleryButtonDisplayState => {
  const root = slot.always(getIntrinsicElementProps("div", { ref, ...props }), {
    elementType: "div",
  });

  const stackWrapper = slot.always(props.stackWrapper, {
    elementType: "div",
  });

  const state: AppPreviewGalleryButtonDisplayState = {
    ...props,
    components: {
      root: "div",
      stackWrapper: "div",
    },
    root,
    stackWrapper,
  };
  state.onGalleryButtonExecute = props.onGalleryButtonExecute;

  return state;
};
